import AsyncStorage from '@react-native-async-storage/async-storage'
import { type Language } from './generated/i18n-meta'

export const LANGUAGE_STORAGE_KEY = '__tolgee_currentLanguage'

export async function getPersistedLanguage(): Promise<Language | null> {
  try {
    const stored = await AsyncStorage.getItem(LANGUAGE_STORAGE_KEY)

    if (!stored) {
      return null
    }

    return stored as Language
  } catch {
    return null
  }
}
